import { hpostRequest, hgetRequest } from '@u/htools.axios.js';

/*
 *@Description: 故障列表
 *@MethodAuthor:  myw
 *@Date: 2020-12-17 09:56:54   fault
 */
export const faultListService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				pageNum: 1,
				pageSize: 10,
				name: '',
				...data
			};
			const res = await hpostRequest('hlzlong/problem/problemAllQuery', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 故障添加
 *@MethodAuthor:  myw
 *@Date: 2020-12-17 10:00:29
 */
export const faultAddService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				name: '',
				...data
			};
			const res = await hpostRequest('hlzlong/problem/problemAdd', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 故障编辑
 *@MethodAuthor:  myw
 *@Date: 2020-12-17 10:12:58
 */
export const faultEditService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				id: '',
				name: '',
				...data
			};
			const res = await hpostRequest('hlzlong/problem/problemUpdate', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 故障详情
 *@MethodAuthor:  myw
 *@Date: 2020-12-17 09:59:21
 */
export const faultDetailService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				problemId: '',
				...data
			};
			const res = await hgetRequest('hlzlong/problem/problemByIdQuery', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 故障删除
 *@MethodAuthor:  myw
 *@Date: 2020-12-17 10:12:03
 */
export const faultDeleteService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				ids: [],
				...data
			};
			const res = await hpostRequest('hlzlong/problem/problemDel', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};

export default faultListService;
